import { FormControlDependsOnSchema } from "@generation/core";

import { useDataContext } from "../Context/DataContextProvider";
import { IUseDependsOnHookResult } from "../Interfaces/IUseDependsOnHookResult";
import { getDependsonResult } from "../Utils/getDependsonResult";

export const useDependsOnHook = (
  baseName: string,
  dependsOn?: FormControlDependsOnSchema[]
): IUseDependsOnHookResult => {
  return getDependsonResult(baseName, useDataContext(), dependsOn);
};
